import {
  ITicketManagementActionCreator,
  ITicketManagementActionTypes,
} from "models/ITicketManagementState";

const initialState: any = {
  tasklist: {},
  createtask: {
    status: null,
    message: "",
    is_api_in_request: false,
  },
  updatetask: {
    status: null,
    message: "",
    is_api_in_request: false,
  },
  gettaskdetails: null,
  requestedtasks: {},
  assignedtasks: {},
  categoriesList: {},
  subcategoriesList: {},
};

const reducer = (
  state = initialState,
  { type, payload }: ITicketManagementActionCreator
) => {
  switch (type) {
    case ITicketManagementActionTypes.FETCH_CATEGORIES_LIST_REQUEST:
      return {
        ...state,
        categoriesList: {},
      };
    case ITicketManagementActionTypes.FETCH_CATEGORIES_LIST_SUCCESS:
      return {
        ...state,
        categoriesList: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_CATEGORIES_LIST_FAILURE:
      return {
        ...state,
        categoriesList: {},
      };

    case ITicketManagementActionTypes.FETCH_SUB_CATEGORIES_LIST_REQUEST:
      return {
        ...state,
        subcategoriesList: {},
      };
    case ITicketManagementActionTypes.FETCH_SUB_CATEGORIES_LIST_SUCCESS:
      return {
        ...state,
        subcategoriesList: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_SUB_CATEGORIES_LIST_FAILURE:
      return {
        ...state,
        subcategoriesList: {},
      };

    case ITicketManagementActionTypes.FETCH_TASK_LIST_DETAILS_REQUEST:
      return {
        ...state,
        tasklist: {},
      };
    case ITicketManagementActionTypes.FETCH_TASK_LIST_DETAILS_SUCCESS:
      return {
        ...state,
        tasklist: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_TASK_LIST_DETAILS_FAILURE:
      return {
        ...state,
        tasklist: {},
      };

    case ITicketManagementActionTypes.CREATE_NEW_TASK_REQUEST:
      return {
        ...state,
        createtask: {
          is_api_in_request: true,
        },
      };
    case ITicketManagementActionTypes.CREATE_NEW_TASK_SUCCESS:
      return {
        ...state,
        createtask: {
          is_api_in_request: false,
          ...payload,
        },
      };
    case ITicketManagementActionTypes.CREATE_NEW_TASK_FAILURE:
      return {
        ...state,
        createtask: {
          is_api_in_request: false,
          ...payload,
        },
      };
    case ITicketManagementActionTypes.RESET_NEW_TASK_STATUS:
      return {
        ...state,
        createtask: initialState.createtask,
      };
    case ITicketManagementActionTypes.UPDATE_NEW_TASK_REQUEST:
      return {
        ...state,
        updatetask: {
          is_api_in_request: true,
        },
      };
    case ITicketManagementActionTypes.UPDATE_NEW_TASK_SUCCESS:
      return {
        ...state,
        updatetask: {
          is_api_in_request: false,
          ...payload,
        },
      };
    case ITicketManagementActionTypes.UPDATE_NEW_TASK_FAILURE:
      return {
        ...state,
        updatetask: {
          is_api_in_request: false,
          ...payload,
        },
      };
    case ITicketManagementActionTypes.RESET_UPDATE_TASK_STATUS:
      return {
        ...state,
        updatetask: initialState.updatetask,
      };

    case ITicketManagementActionTypes.FETCH_TASK_DETAILS_REQUEST:
      return {
        ...state,
        gettaskdetails: {},
      };
    case ITicketManagementActionTypes.FETCH_TASK_DETAILS_SUCCESS:
      return {
        ...state,
        gettaskdetails: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_TASK_DETAILS_FAILURE:
      return {
        ...state,
        gettaskdetails: {
          ...payload,
        },
      };

    case ITicketManagementActionTypes.FETCH_REQUESTED_TASK_DETAILS_REQUEST:
      return {
        ...state,
        requestedtasks: {},
      };
    case ITicketManagementActionTypes.FETCH_REQUESTED_TASK_DETAILS_SUCCESS:
      return {
        ...state,
        requestedtasks: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_REQUESTED_TASK_DETAILS_FAILURE:
      return {
        ...state,
        gettaskdetails: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_ASSIGNED_TASK_DETAILS_REQUEST:
      return {
        ...state,
        assignedtasks: {},
      };
    case ITicketManagementActionTypes.FETCH_ASSIGNED_TASK_DETAILS_SUCCESS:
      return {
        ...state,
        assignedtasks: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_ASSIGNED_TASK_DETAILS_FAILURE:
      return {
        ...state,
        assignedtasks: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_TICKETS_ANALYTICS_REQUEST:
      return {
        ...state,
        ticketsanalytics: {},
      };
    case ITicketManagementActionTypes.FETCH_TICKETS_ANALYTICS_SUCCESS:
      return {
        ...state,
        ticketsanalytics: {
          ...payload,
        },
      };
    case ITicketManagementActionTypes.FETCH_TICKETS_ANALYTICS_FAILURE:
      return {
        ...state,
        ticketsanalytics: {
          ...payload,
        },
      };
    default:
      return state;
  }
};

export default reducer;
